import { MediaType, MediaTypeEnum } from '../types';
import { capitalize } from '../../../utils/strings';

export const formatType = (t: MediaType) =>
    t === MediaTypeEnum.Image ? 'Photograph' : capitalize(t);
